
import { defineComponent } from "vue";
import dateFormat from "@/utils/dateFormat";
export default defineComponent({
  name: "Notice",
  props: {
    notice: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup() {
    function formatAvatar(id: string, item: any) {
      let src = "";
      if (!Number(id)) {
        src =
          "https://beinabncc.oss-cn-beijing.aliyuncs.com/News/1e0ba2777e56d0e72327afb20bcb792a.jpg";
      } else {
        src = item.user.userImg;
      }
      return src
    }
    return {
      dateFormat,
      formatAvatar,
    };
  },
});
